// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@ces/Overrides/Widgets/SignIn/SignInExistingAccount";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.signInExistingAccountContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 32px;

        ${xScreen("lt", "md")} {
            margin-top: ${({ isCheckoutPage }: any) => (isCheckoutPage ? 0 : "16px")};
        }
    `,
};

signInExistingAccountStyles.form = {
    css: css`
        width: 100%;
        max-width: 430px;

        ${({ isCheckoutPage }: any) =>
            isCheckoutPage
                ? css`
                      border-bottom: none;
                      padding-bottom: 0;
                      margin-bottom: 0;
                  `
                : css`
                      border-bottom: 1px solid ${color("common.ui4")};
                      padding-bottom: 25px;
                      margin-bottom: 25px;
                  `};

        ${xScreen("lt", "md")} {
            max-width: 100%;
        }
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
    `,
};

signInExistingAccountStyles.passwordLabelContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    color: "secondary",
    typographyProps: {
        size: 10,
        lineHeight: "11px",
        weight: fontConfig.weight.bold,
    },
    css: css`
        height: 9px;
    `,
};

signInExistingAccountStyles.userNameGridItem = {
    width: 12,
    css: css`
        padding: 16px 15px 8px;
    `,
};

signInExistingAccountStyles.passwordGridItem = {
    width: 12,
    css: css`
        padding: 8px 15px;
    `,
};

signInExistingAccountStyles.rememberMeGridItem = {
    width: 6,
    css: css`
        padding: 12px 15px;
        align-items: center;

        ${xScreen("lt", "md")} {
            ${({ isCheckoutPage }: any) => (isCheckoutPage ? "padding: 12px 15px 0" : "")}
        }
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        padding: 12px 15px;

        ${xScreen("lt", "md")} {
            ${({ isCheckoutPage }: any) => (isCheckoutPage ? "padding: 12px 15px 0" : "")}
        }
    `,
};

signInExistingAccountStyles.signInButton = {
    css: css`
        ${xScreen("lt", "md")} {
            width: 80px;
        }
    `,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 16px;
        width: 100%;
        max-width: 430px;

        ${xScreen("lt", "md")} {
            max-width: 100%;
        }
    `,
};
